import React, { Component } from "react";
import { checkMobileCode } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { connect } from "react-redux";

class MobileCode extends Component {
  state = {
    verificationCode: null,
    codeCheckedResult: null,
  };

  handleInput = (e) => {
    this.setState({
      verificationCode: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.checkMobileCode(
      this.state.verificationCode,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = (res) => {
    this.props.onProcessEnd();
    console.dir(res);
    this.setState({ codeCheckedResult: res });
  };
  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  renderStatus = () => {
    if (
      this.state.codeCheckedResult &&
      this.state.codeCheckedResult.data.success
    ) {
      return <div>Başarılı!</div>;
    }
  };

  render() {
    return (
      <>
        {this.renderStatus()}
        <div>Telefonunuza gelen kod : </div>
        <div>
          <input
            type="text"
            onChange={this.handleInput}
            value={this.state.verificationCode}
          ></input>
          <button type="submit" onClick={this.handleSubmit}>
            Doğrula
          </button>
        </div>
      </>
    );
  }
}

export default connect(null, { checkMobileCode })(
  containsLongRunningProcess(MobileCode)
);
